import React from "react";

const ThreePhoneCommonMainAction = ({ heading, show_subHeading, imgSrc }) => {
  return (
    <section className="section-p">
    <div className="bg__img">
      <div className="home__section1">
        <div className="page-width">
          <h1 className="home__section1-txt1 text-jost-sb-50-wt">{heading}</h1>
          {show_subHeading && (
            <p className="home__section1-para text-ops-rg-16-wt">
              Welcome to Timely Golf. By downloading and using our App, you will
              help eliminate the curse of “Slow Play” and be able to enjoy a
              stress-free and enjoyable round. Our App will monitor all golfers
              on the golf course, ensuring all golfers play at a reasonable pace
              (predefined by the club) and providing the means for them to
              immediately identify any slow play and quickly take action to
              rectify it.
            </p>
          )}
          <div className="home__section1__three_img">
            <img src={imgSrc} alt="three_pic" />
          </div>
          <h2 className="home__section1-txt2 text-jost-sb-22-lg">
            Available to download on:
          </h2>
          <div className="home__section1__logo">
            <a
              href="https://www.apple.com/in/app-store/"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src={
                  require("../../assets/images/pages/home/applestore.svg")
                    .default
                }
                alt=""
                className="home__section1__right__logo-logo1"
              />
            </a>
            <a
              href="https://play.google.com/store"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src={
                  require("../../assets/images/pages/home/googlestore.svg")
                    .default
                }
                alt=""
                className="home__section1__right__logo-logo2"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
};

export default ThreePhoneCommonMainAction;
